// extracted by mini-css-extract-plugin
module.exports = {"BottomMenu":"BottomMenu_BottomMenu__3IGkF","Link":"BottomMenu_Link__2mYhP","Btn":"BottomMenu_Btn__3YdgO","Icon":"BottomMenu_Icon__21dI0"};